import { Tag } from 'antd'

import { StrictOmit } from '../../../../types/utilities'
import { FieldBooleanProps } from '../../interface'

const isTrue = (value?: string | boolean | number) =>
  value === true || value === 'true' || value === 1

export const FieldBoolean = ({
  className,
  style,
  value,
  trueText = '是',
  falseText = '否'
}: StrictOmit<FieldBooleanProps, 'type'>) => {
  return (
    <Tag
      className={className}
      color={isTrue(value) ? 'green' : 'red'}
      style={style}
    >
      {isTrue(value) ? trueText : falseText}
    </Tag>
  )
}
